import { Serializable } from "../core";

export class Size implements Serializable<Size> {
  id!: number;
  size!: string;

  deserialize(json: any): Size {
    this.id = json.id;
    this.size = json.size;
    return this;
  }
}
